import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import { functions } from "@/firebase";
import { httpsCallable } from "firebase/functions";
import { ApiError } from "@/types/api";

export interface AnalyzeCatalogResponse {
  products: {
    id: string;
    title: string;
    description: string;
    price: number | null;
  }[];
  sections: {
    category: string;
    products: string[];
  }[];
}

export const aiCatalogApi = createApi({
  reducerPath: "aiCatalogApi",
  baseQuery: fakeBaseQuery<ApiError>(),
  endpoints: (builder) => ({
    analyzeCatalog: builder.mutation<
      AnalyzeCatalogResponse,
      { organizationId: string; catalogId: string; filePaths: string[] }
    >({
      queryFn: async ({ organizationId, catalogId, filePaths }) => {
        try {
          const analyzeCatalogFunc = httpsCallable<
            { organizationId: string; catalogId: string; filePaths: string[] },
            AnalyzeCatalogResponse
          >(functions, "analyzeCatalog");
          const result = await analyzeCatalogFunc({ organizationId, catalogId, filePaths });
          return { data: result.data };
        } catch (error: any) {
          console.error("RTK Query: analyzeCatalog error:", error);
          return {
            error: {
              status: 500,
              statusText: error.message || "Error al analizar las imágenes con Gemini",
            },
          };
        }
      },
    }),
    cleanupTempCatalogImages: builder.mutation<
      { success: boolean },
      { organizationId: string; catalogId: string }
    >({
      queryFn: async ({ organizationId, catalogId }) => {
        try {
          const cleanupFunc = httpsCallable<
            { organizationId: string; catalogId: string },
            { success: boolean }
          >(functions, "cleanupTempCatalogImages");
          const result = await cleanupFunc({ organizationId, catalogId });
          return { data: result.data };
        } catch (error: any) {
          console.error("RTK Query: cleanupTempCatalogImages error:", error);
          return {
            error: {
              status: 500,
              statusText: error.message || "Error al limpiar las imágenes temporales de Storage",
            },
          };
        }
      },
    }),
  }),
});

export const { useAnalyzeCatalogMutation, useCleanupTempCatalogImagesMutation } = aiCatalogApi;
